import { render, staticRenderFns } from "./CollectionPayments.vue?vue&type=template&id=654c31b4&"
import script from "./CollectionPayments.vue?vue&type=script&lang=js&"
export * from "./CollectionPayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CollectionPayments.vue"
export default component.exports